import {
  GetWarehouseStockResponse,
  IncludeExcludeFilterCategory,
  PaginatedFilterQuery,
  PaginatedResultDto_1OfCombinedWarehouseOrderItemDto,
  WarehouseClient,
} from "@lib/ShiOneClient";
import { ApiClientConfig } from "../../../../../auth/ApiClientConfig";

const api = new WarehouseClient(
  ApiClientConfig,
  import.meta.env.API_ENDPOINT
);

export async function getWarehouseStock(): Promise<GetWarehouseStockResponse> {
  return api.getWarehouseStock();
}

export async function getWarehouseOrders(
  query: PaginatedFilterQuery,
): Promise<PaginatedResultDto_1OfCombinedWarehouseOrderItemDto> {
  return api.getWarehouseOrders(query);
}

export async function getWarehouseOrdersPicklist(): Promise<IncludeExcludeFilterCategory[]> {
  return api.getWarehouseOrdersPicklist();
}
